import React, { useState, useEffect, useCallback } from 'react';
import { _T, C } from '../../../shared/theme';
import { s_PB, s_GC, s_GB } from '../../../shared/styles';
import { saveGameScore } from '../../../shared/utils';

const S = 7; // grid size

// Simple maze: 1=wall, 0=path
const MAZES = [
  {
    grid:[
      [0,1,0,0,0,1,0],
      [0,1,0,1,0,1,0],
      [0,0,0,1,0,0,0],
      [1,1,0,1,1,1,0],
      [0,0,0,0,0,1,0],
      [0,1,1,1,0,1,0],
      [0,0,0,1,0,0,0],
    ],
    start:[0,0], end:[6,6],
  },
  {
    grid:[
      [0,0,0,1,0,0,0],
      [1,1,0,1,0,1,0],
      [0,0,0,0,0,1,0],
      [0,1,1,1,1,1,0],
      [0,0,0,0,0,0,0],
      [1,1,0,1,1,0,1],
      [0,0,0,0,1,0,0],
    ],
    start:[0,0], end:[6,6],
  },
];

function MentalMazeGame({ lang, onBack }) {
  const nl = lang === 'nl';
  const [mazeIdx, setMazeIdx] = useState(0);
  const [pos, setPos] = useState([0, 0]);
  const [moves, setMoves] = useState(0);
  const [phase, setPhase] = useState('playing'); // playing | won
  const [score, setScore] = useState(0);
  const maze = MAZES[mazeIdx];

  const move = useCallback((dr, dc) => {
    if (phase !== 'playing') return;
    const [r, c] = pos;
    const nr = r + dr, nc = c + dc;
    if (nr < 0 || nr >= S || nc < 0 || nc >= S) return;
    if (maze.grid[nr][nc] === 1) return;
    const newPos = [nr, nc];
    setPos(newPos); setMoves(m => m + 1);
    if (nr === maze.end[0] && nc === maze.end[1]) {
      const s = Math.max(0, 100 - moves * 3);
      setScore(s); setPhase('won');
      saveGameScore('mentalmaze', s);
    }
  }, [pos, phase, maze, moves]);

  const restart = () => {
    const next = (mazeIdx + 1) % MAZES.length;
    setMazeIdx(next); setPos([0, 0]); setMoves(0); setPhase('playing');
  };

  return (
    <div>
      <button onClick={onBack} style={{ background: 'none', border: 'none', color: C.silver, cursor: 'pointer', fontSize: 13, marginBottom: 12 }}>← {nl ? 'Terug' : 'Back'}</button>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
        <span style={{ color: C.silver, fontSize: 12 }}>{nl ? `Stappen: ${moves}` : `Moves: ${moves}`}</span>
        <span style={{ color: _T.accent, fontSize: 12 }}>🏁 {nl ? 'Bereik het doel' : 'Reach the goal'}</span>
      </div>

      {/* Maze grid */}
      <div style={{ display: 'grid', gridTemplateColumns: `repeat(${S}, 1fr)`, gap: 3, marginBottom: 16, padding: 8, background: _T.bg4, borderRadius: 14 }}>
        {maze.grid.map((row, r) => row.map((cell, c) => {
          const isPlayer = pos[0] === r && pos[1] === c;
          const isEnd = maze.end[0] === r && maze.end[1] === c;
          const isStart = maze.start[0] === r && maze.start[1] === c;
          return (
            <div key={`${r}-${c}`} style={{ paddingTop: '100%', position: 'relative', borderRadius: 6, background: cell === 1 ? '#1a2a4a' : isPlayer ? '#7B6FD0' : isEnd ? '#4AC87A33' : isStart ? '#D4873A11' : '#0d1829' }}>
              {(isPlayer || isEnd) && (
                <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.8vw' }}>
                  {isPlayer ? '🔵' : '🏁'}
                </div>
              )}
            </div>
          );
        }))}
      </div>

      {phase === 'won' && (
        <div style={{ ...s_GC({ padding: 16, textAlign: 'center', marginBottom: 12 }) }}>
          <div style={{ fontSize: 36, marginBottom: 4 }}>🎉</div>
          <div style={{ color: C.white, fontWeight: 700 }}>{nl ? `Klaar in ${moves} stappen!` : `Done in ${moves} moves!`}</div>
          <button style={s_PB({ width: '100%', marginTop: 10 })} onClick={restart}>{nl ? 'Volgend doolhof' : 'Next maze'}</button>
        </div>
      )}

      {/* Controls */}
      {phase === 'playing' && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gridTemplateRows: '1fr 1fr 1fr', gap: 6, maxWidth: 200, margin: '0 auto' }}>
          <div />
          <button style={s_GB({ height: 50, fontSize: 20 })} onClick={() => move(-1, 0)}>↑</button>
          <div />
          <button style={s_GB({ height: 50, fontSize: 20 })} onClick={() => move(0, -1)}>←</button>
          <div />
          <button style={s_GB({ height: 50, fontSize: 20 })} onClick={() => move(0, 1)}>→</button>
          <div />
          <button style={s_GB({ height: 50, fontSize: 20 })} onClick={() => move(1, 0)}>↓</button>
          <div />
        </div>
      )}
    </div>
  );
}

export default MentalMazeGame;
